<div class="font-lexy2000s z-10 flex flex-col items-center gap-16">
  <div #answerContainer class="flex w-full flex-col items-center gap-5">
    <ng-content select="[target]" />

    <div class="flex w-full max-w-xl">
      <div
        [class]="
          cn(
            'flex h-26 w-full items-center gap-1 overflow-y-auto rounded-md border-4 border-dashed border-white bg-white/30 p-5 transition-all',
            isDone() && 'gap-0 border-green-500/50 bg-green-500/25',
            wrongKey() && 'border-red-500/50 bg-red-500/25'
          )
        "
      >
        <div
          [class]="
            cn(
              'flex w-fit gap-1 overflow-y-auto transition-all',
              isDone() && 'border-surface-300 gap-0 rounded-md border-2 bg-white first:pl-4 last:pr-4'
            )
          "
        >
          @for (key of value(); let i = $index; track i) {
            <div #key>
              <lib-key [class]="cn('transition-all', isDone() ? 'rounded-none border-none px-1' : '')" [key]="key" />
            </div>
          }
        </div>

        @if (wrongKey()) {
          <lib-key [key]="wrongKey()!" class="rounded border-red-400/75 bg-red-500/50 text-white" />
        }
      </div>

      <ng-content select="[input-bar]" />
    </div>
  </div>

  <lib-keyboard (keyPress)="onKeyPress($event)" [disabled]="!!wrongKey() || isDone()" [rows]="keyboardRows()" />
</div>
